import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
// import PropTypes from 'prop-types';

// SimpleTable.propTypes = {
//   data: PropTypes.object || PropTypes.array
// };

// eslint-disable-next-line
function SimpleTable({ data }) {
  const [isArray, setIsArray] = useState(false);
  const [head, setHead] = useState([]);
  const [body, setBody] = useState([]);
  let show;
  useEffect(() => {
    if (Array.isArray(data)) {
      setHead(Object.keys(data[0]));
      setBody(data);
      setIsArray(true);
    } else {
      setHead(Object.keys(data));
      setBody(Object.values(data));
      setIsArray(false);
    }
  }, [data]);

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  if (isArray) {
    show = body.map((row, id) => {
      const detail = Object.values(row);
      return (
        <TableRow key={id}>
          {detail.map((det, id) => (
            <TableCell key={id}>{det}</TableCell>
          ))}
        </TableRow>
      );
    });
  } else {
    show = (
      <TableRow>
        {body?.map((tab, id) => (
          <TableCell key={id}>{tab}</TableCell>
        ))}
      </TableRow>
    );
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          {head.map((tab) => (
            <TableCell key={tab}>{capitalizeFirstLetter(tab)}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>{show}</TableBody>
    </Table>
  );
}

export default SimpleTable;
